module.exports = __webpack_public_path__ + "static/img/query-tips.0d94ebc2.png";